module.exports = __webpack_public_path__ + "static/media/ceb.bd60c15e.jpg";